import { useState, useEffect, useRef } from "react";
import { ORG_CLIENT_BILLFEE_REMAINDER,ORG_DELETE_INVOICE,ORG_DOWNLOAD_INVOICE_DOC, ORG_PRINT_RECEIPT } from "../../../../ApiServices/BaseURL";
import { postData,getData } from "../../../../ApiServices/ApiService";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../../../GlobalContext/GlobalContext";
import { logFrontendException } from "../../../../Utils/Exception";

const useBillingController = (billFeeList,clientInfo,onRefresh) => {
  const [selectAll, setSelectAll] = useState(false);
  const [checkedStates, setCheckedStates] = useState([]);
  const [selectedTaskIds, setSelectedTaskIds] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState(billFeeList || []);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const invoiceInfoRef = useRef(null);
  const [deleteLoading, setDeleteLoading] = useState({});
  const [printInvoiceError, setPrintInvoiceError] = useState({});
  const [successMesg, setSuccessMesg] = useState({});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const navigate = useNavigate();
  const [sendReminderError,setSendReminderError] = useState('');
  const [sendReminderSucces,setSendReminderSucces] = useState('');
  const [sendReminderLoader,setSendReminderLoader] = useState(false);
  const { setIsLoginPopup } = useTheme();

   const pageName = 'useBillingController';
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

  const services = [
    {
      serviceName: "GST Filling",
      fees: 2000,
      frequency: "Yearly",
      remark: "Yearly",
      status: "Paid",
      invoiceLink: "https://example.com/invoice/gst",
    },
    {
      serviceName: "Company Reg",
      fees: 2000,
      frequency: "Yearly",
      remark: "Yearly",
      status: "Not Submitted",
      invoiceLink: "https://example.com/invoice/company-reg",
    },
    {
      serviceName: "Company Registration",
      fees: 2000,
      frequency: "Yearly",
      remark: "Yearly",
      status: "Pending",
      invoiceLink: "https://example.com/invoice/company-registration",
    },
    {
      serviceName: "ITR",
      fees: 2000,
      frequency: "Yearly",
      remark: "Yearly",
      status: "Pending",
      invoiceLink: "https://example.com/invoice/itr",
    },
    {
      serviceName: "Retention Charges",
      fees: 2000,
      frequency: "Monthly",
      remark: "Monthly",
      status: "Pending",
      invoiceLink: "https://example.com/invoice/retention",
    },
  ];

  const getStatusStyle = (status) => {
    switch (status) {
      case 2:
        return { backgroundColor: "#d4edda", color: "#155724" }; // Green // paid
        case 3:
        return { backgroundColor: "#d4edda", color: "#155724" }; // Green // partially paid
      // case "New":
      //   return { backgroundColor: "#fff3cd", color: "#856404" }; // Yellow
      case 1:
        return { backgroundColor: "#f8d7da", color: "#721c24" }; // Red // pending
      case 4:
        return { backgroundColor: "#fff3cd", color: "#856404" }; // Yellow // paid online
      
      default:
        return {};
    }
  };

  const totalBalance = filteredTasks.reduce((acc, service) => acc + service?.invoice_amt_bal, 0);

  const handleSelectAll = (isChecked) => {
    setSelectAll(isChecked);
    // Update taskList to mark all as checked or unchecked
    const updatedBillList = filteredTasks.map((invoice) => {
      const isDisabled =
        invoice.invoice_status === 2 ||
        invoice.invoice_id === 0 ||
        invoice.advance_pay_flag === 1;
  
      return {
        ...invoice,
        checked: isDisabled ? invoice.checked : isChecked,
      };
    });
    setFilteredTasks(updatedBillList);


    if (isChecked) {
      // Only add invoice IDs with status !== 2
    const selectedIds = filteredTasks
    .filter(invoice =>
      invoice.invoice_status !== 2 &&
      invoice.invoice_id !== 0 &&
      invoice.advance_pay_flag !== 1
    )
    .map(invoice => invoice.invoice_id);

    setSelectedTaskIds(selectedIds);
      // Add all task IDs to the selectedTaskIds list
      // setSelectedTaskIds(
      //   filteredTasks
      //     .map(invoice => invoice?.invoice_id)
      // );
    } else {
      // Clear the selectedTaskIds list
      setSelectedTaskIds([]);
    }
  };

  const handleCheckboxChange = (isChecked, invoiceId) => {
    // Update the checked status of the task based on taskId
    const updatedBillList = filteredTasks.map((invoice) =>
      invoice.invoice_id === invoiceId ? { ...invoice, checked: isChecked, invoice_id: invoiceId } : invoice
    );

    setFilteredTasks(updatedBillList);

    // Manage selected task IDs
    setSelectedTaskIds((prev) => {
      const updatedInvoiceIds = isChecked
        ? [...prev, invoiceId] // Add taskId if checked
        : prev.filter((id) => id !== invoiceId); // Remove taskId if unchecked

      return [...new Set(updatedInvoiceIds)]; // Ensure no duplicates
    });

    // Check if all tasks are checked
    const allChecked = updatedBillList.every((task) => task.checked);
    setSelectAll(allChecked);
  };

  useEffect(() => {
    setFilteredTasks(billFeeList);
  }, [billFeeList]);

  const totalPages = Math.ceil(filteredTasks?.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTasks = filteredTasks.slice(indexOfFirstItem, indexOfLastItem);
  console.log('totalPages:-', totalPages)

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const maxVisiblePages = 3;

  const getVisiblePages = () => {
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust startPage if we're near the end
    const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

    return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
  };

  const visiblePages = getVisiblePages();

  const handleInvoiceDwd = async (invoiceId) => {
    try {
      // setPrintInvoiceLoading(true);
      if(deleteLoading[invoiceId]){
        return
      }
      setDeleteLoading((prev) => ({ ...prev, [invoiceId]: true }));
      setPrintInvoiceError({});
      setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: '' }));
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_DOWNLOAD_INVOICE_DOC}?emp_id_auth=${storedUserInfo?.emp_id}&invoice_id=${invoiceId}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const downloadUrl = responseData?.dataJ?.[0]?.download_url;
              if (downloadUrl) {
                try {
                  // Fetch the file as a blob
                  const fileResponse = await fetch(downloadUrl);
                  const blob = await fileResponse.blob();
        
                  // Create a temporary object URL for the blob
                  const url = window.URL.createObjectURL(blob);
        
                  // Create a link and trigger download
                  const link = document.createElement('a');
                  link.href = url;
        
                  // Extract the file extension from the download URL or set a default
                  const fileExtension = downloadUrl.includes('.')
                    ? downloadUrl.split('.').pop().split('?')[0]
                    : ''; // Default to 'pdf' if no extension found
        
                  const filename = `Invoice_${invoiceId}.${fileExtension}`;
                  link.setAttribute('download', filename);
        
                  document.body.appendChild(link);
                  link.click();
        
                  // Clean up
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(url);
                } catch (error) {
                  console.error('Error downloading file:', error);
                  setPrintInvoiceError('An error occurred while attempting to download the file. Please try again.');
                  logFrontendException(storedUserId, pageName, "invoicedwd", responseData || '');
                }
              } else {
                setPrintInvoiceError('Download URL not available.');
                logFrontendException(storedUserId, pageName, "invoicedwd", responseData?.info || '');
              }
            } else {
              setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: responseData?.info || 'Data Not Found' }));
              logFrontendException(storedUserId, pageName, "invoicedwd", responseData?.info || '');
            }
          } else {
            console.log(responseData?.info || 'Failed to download invoice. Please try again.');
            setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: responseData?.info || 'Failed to download invoice. Please try again.' }));
            logFrontendException(storedUserId, pageName, "invoicedwd", responseData?.info || '');
          }
        } else {
          setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: responseData?.info || 'Failed to download invoice. Status code error.' }));
          logFrontendException(storedUserId, pageName, "invoicedwd", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
       setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: 'Unauthorized access. Your session may have expired. Please log in again.' }));
       logFrontendException(storedUserId, pageName, "invoicedwd", responseData || '');
      setIsLoginPopup(true)
      }
      // Unexpected or network-related errors
      else {
        setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: 'Unexpected error occurred. Please try again later.' }));
        logFrontendException(storedUserId, pageName, "invoicedwd", responseData || '');
      }
    } catch (error) {
     
        setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: `Failed to download invoice. Please check your network connection and try again.` }));
        logFrontendException(storedUserId, pageName, "invoicedwd", error || '');
    
    } finally {
      // setPrintInvoiceLoading(false);
      setDeleteLoading((prev) => ({ ...prev, [invoiceId]: false }));
    }
  }
  const handleReceiptDwd =async (invoiceId,recieptId)=>{
    console.log('gen pdf reciept Id:-',recieptId)
    try {
      // setPrintInvoiceLoading(true);
      if(deleteLoading[invoiceId]){
        return
      }
      setDeleteLoading((prev) => ({ ...prev, [invoiceId]: true }));
      setPrintInvoiceError({});
      setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: '' }));
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_PRINT_RECEIPT}?emp_id_auth=${storedUserInfo?.emp_id}&receipt_id=${recieptId}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const downloadUrl = responseData?.dataJ?.[0]?.download_url;
              if (downloadUrl) {
                try {
                  // Fetch the file as a blob
                  const fileResponse = await fetch(downloadUrl);
                  const blob = await fileResponse.blob();
        
                  // Create a temporary object URL for the blob
                  const url = window.URL.createObjectURL(blob);
        
                  // Create a link and trigger download
                  const link = document.createElement('a');
                  link.href = url;
        
                  // Extract the file extension from the download URL or set a default
                  const fileExtension = downloadUrl.includes('.')
                    ? downloadUrl.split('.').pop().split('?')[0]
                    : ''; // Default to 'pdf' if no extension found
        
                  const filename = `Reciept_${recieptId}.${fileExtension}`;
                  link.setAttribute('download', filename);
        
                  document.body.appendChild(link);
                  link.click();
        
                  // Clean up
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(url);
                } catch (error) {
                  console.error('Error downloading file:', error);
                  setPrintInvoiceError('An error occurred while attempting to download the file. Please try again.');
                }
              } else {
                setPrintInvoiceError('Download URL not available.');
              }
            } else {
              setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: responseData?.info || 'Data Not Found' }));
              logFrontendException(storedUserId, pageName, "ReceiptDwd", responseData?.info || '');
            }
          } else {
            console.log(responseData?.info || 'Failed to fetch reciept document. Please try again.');
            setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: responseData?.info || 'Failed to download receipt. Please try again.' }));
            logFrontendException(storedUserId, pageName, "ReceiptDwd", responseData?.info || '');
          }
        } else {
          setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: responseData?.info || 'Failed to download receipt. Status code error.' }));
          logFrontendException(storedUserId, pageName, "ReceiptDwd", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
       setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: 'Unauthorized access. Your session may have expired. Please log in again.' }));
       logFrontendException(storedUserId, pageName, "ReceiptDwd", responseData || '');
       setIsLoginPopup(true)
      
      }
      // Unexpected or network-related errors
      else {
        setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: 'Unexpected error occurred. Please try again later.' }));
        logFrontendException(storedUserId, pageName, "ReceiptDwd", responseData || '');
      }
    } catch (error) {
     
        setPrintInvoiceError((prev) => ({ ...prev, [invoiceId]: `Failed to download receipt. Please check your network connection and try again.` }));
        logFrontendException(storedUserId, pageName, "ReceiptDwd-catch", error || '');
    
    } finally {
      // setPrintInvoiceLoading(false);
      setDeleteLoading((prev) => ({ ...prev, [invoiceId]: false }));
    }
  }
  const handleSendReminder = async ()=>{
    console.log('gen pdf handleSendReminder:-',selectedTaskIds);
          try {
            setSendReminderSucces('');
            setSendReminderError(''); // Clear any existing error
            if(selectedTaskIds.length < 1){
              setSendReminderError('Please select atleast one service'); return
            }
              setSendReminderLoader(true); // Start loading
      
                const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
                const payLoad ={
                  "emp_id_auth": storedUserInfo?.emp_id,
                  "invoice_id": selectedTaskIds,
                  "client_id": clientInfo?.client_id || 0,
                }
                // console.log('payLoad:-',payLoad);
      
                // Make the API call
               const response = await postData(ORG_CLIENT_BILLFEE_REMAINDER,payLoad)
                const responseData = await response.json();
      
                // Check for success (200) and internal status code
                if (response?.status === 200) {
                    if (responseData?.statusCode === 200) {
                        if (responseData?.message.toLowerCase() === 'success') {
                          setSendReminderSucces(responseData?.info || '');
                            setTimeout(() => {
                              setSendReminderSucces('')
                            }, 3000);
                        } else {
                          setSendReminderError(responseData?.info || 'Failed to send remainder.');
                          logFrontendException(storedUserId, pageName, "sendReminder", responseData?.info || '');
                        }
                    } else {
                      setSendReminderError(responseData?.info || 'Error Occurred while sending remainder.');
                      logFrontendException(storedUserId, pageName, "sendReminder", responseData?.info || '');
                    }
                }// Token-related errors: 400, 401, 403
                else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                  setSendReminderError('Unauthorized access. Your session may have expired. Please log in again.');
                  logFrontendException(storedUserId, pageName, "sendReminder", responseData || '');
                    
                  setIsLoginPopup(true)
                } else {
                  setSendReminderError('Failed to send remainder. Please try again later.');
                  logFrontendException(storedUserId, pageName, "sendReminder", responseData || '');
                }
            } catch (error) {
              setSendReminderError(`Failed to send remainder. Please check your network connection and try again.`);
              logFrontendException(storedUserId, pageName, "sendReminder-catch", error || '');
               
            } finally {
              setSendReminderLoader(false)
            }
  }

  const handleInvoiceEdit =(invoiceinfo)=>{
    console.log('invoiceinfo:',invoiceinfo)
    // if (userPermissions?.invoices?.per_name_sub_json?.invoice_edit === 1) {
      navigate("/generate-invoice", {
        state: { rowData: invoiceinfo ,pageType: null, preInvoiceData: null},
      });
    // }
  }


  const handleAddInvoice =()=>{
    const preInvoiceData = {
      "clientSelectedInfo": clientInfo,
      "groupInfo": {},
      "groupClient":null,
      "generatedBy":null,
      "systemBillingAmount":0,
      "estimateAmount":0,
      "send_update_client": false,
      "send_update_team": false,
      "tasks_list_selected": [],
      "services_list_selected": [],
      "estimate_for": 'Client',
      "estimate_type": true,
      "groupTaskList": [],
      "taskList": [],
      "pageType": 'taskListPage'
  }
  console.log('preInvoiceData:-', preInvoiceData);

  navigate('/generate-invoice', { state: { rowData: null, pageType: 'taskList', preInvoiceData: preInvoiceData } });

  }

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false); // Close the modal
  };

  const confirmDeleteInvoice = (invoice) => {
    invoiceInfoRef.current = invoice;
    setIsDeleteModalOpen(true);
  }

   const handleDeleteInvoiceFile = async (invoiceInfo) => {
        try {
          setDeleteLoading((prev) => ({ ...prev, [invoiceInfo?.invoice_id]: true }));
          setPrintInvoiceError({});
          setPrintInvoiceError((prev) => ({ ...prev, [invoiceInfo?.invoice_id]: '' }));
          const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
          const payLoad = {
            "emp_id_auth": storedUserInfo?.emp_id,
            "invoice_id": invoiceInfo?.invoice_id
          }
    
          // Make the API call
          const response = await postData(ORG_DELETE_INVOICE, payLoad);
          const responseData = await response.json();
    
          // Check for success (200) and internal status code
          if (response?.status === 200) {
            if (responseData?.statusCode === 200) {
              if (responseData?.message.toLowerCase() === 'success') {
                setSuccessMesg((prev) => ({ ...prev, [invoiceInfo?.invoice_id]: responseData?.info || '' }));
                setTimeout(() => {
                  onRefresh();
                  setSuccessMesg((prev) => ({ ...prev, [invoiceInfo?.invoice_id]: '' }))
                }, 3000);
    
              } else {
                console.log(responseData?.info || 'Failed to delete invoice. Please try again.');
                setPrintInvoiceError((prev) => ({ ...prev, [invoiceInfo?.invoice_id]: responseData?.info || 'Failed to delete invoice. Please try again.' }));
                logFrontendException(storedUserId, pageName, "deleteInvoicefile", responseData?.info || '');
              }
            } else {
              setPrintInvoiceError((prev) => ({ ...prev, [invoiceInfo?.invoice_id]: responseData?.info || 'Failed to delete invoice. Status code error.' }));
              logFrontendException(storedUserId, pageName, "deleteInvoicefile", responseData?.info || '');
            }
          }
          // Token-related errors: 400, 401, 403
          else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
            setPrintInvoiceError((prev) => ({ ...prev, [invoiceInfo?.invoice_id]: 'Unauthorized access. Your session may have expired. Please log in again.' }));
            logFrontendException(storedUserId, pageName, "deleteInvoicefile", response || '');
              
            setIsLoginPopup(true)
          }
          // Unexpected or network-related errors
          else {
            setPrintInvoiceError((prev) => ({ ...prev, [invoiceInfo?.invoice_id]: 'Unexpected error occurred. Please try again later.' }));
            logFrontendException(storedUserId, pageName, "deleteInvoicefile", response || '');
          }
        } catch (error) {
          setPrintInvoiceError((prev) => ({ ...prev, [invoiceInfo?.invoice_id]: `Failed to delete invoice. Please check your network connection and try again.` }));
          logFrontendException(storedUserId, pageName, "deleteInvoicefile-catch", error || '');
          
        } finally {
          setDeleteLoading((prev) => ({ ...prev, [invoiceInfo?.invoice_id]: false }));
        }
      }
  return {
    currentTasks,
    services,
    selectAll,
    checkedStates,
    totalBalance,handleAddInvoice,
    handleSelectAll,handleSendReminder,
    handleCheckboxChange,handleInvoiceDwd,handleReceiptDwd,
    getStatusStyle, totalPages, currentPage,
    handlePageChange, visiblePages,
    sendReminderError,sendReminderLoader,sendReminderSucces,
    handleInvoiceEdit,handleDeleteInvoiceFile,
    confirmDeleteInvoice,handleCloseDeleteModal,isDeleteModalOpen,
    successMesg,printInvoiceError,deleteLoading,invoiceInfoRef
  };
};

export default useBillingController;
